import React from 'react';
import { Box, Heading, Text } from 'components';
import { useAsModal } from 'hooks';
import { covertValueTypeToKey, normalizeBuildValue } from 'utils/build';
import { BuildValueModel } from 'generated/models';

interface QuoteDetailsProps {
  buildFor: any;
  buildFrom: any;
  forQuantity: number;
  fromQuantity: number;
  forLeadTime: number;
  fromLeadTime: number;
  fadeIn?: () => void;
}

export const ProductQuoteDetails = ({
  fromQuantity,
  forQuantity,
  fromLeadTime,
  forLeadTime,
  buildFrom,
  buildFor,
  fadeIn,
}: QuoteDetailsProps) => {
  useAsModal(fadeIn);
  const fromProcess = buildFrom.process;
  const forProcess = buildFor.process;

  const fromMaterial = buildFrom.material;
  const forMaterial = buildFor.material;

  const { values } = buildFor;
  const { values: fromValues } = buildFrom;

  let nameFrom = '';
  let valueTypeFrom = '';
  let bValFrom = '';

  return (
    <Box>
      <Heading level={3}>Part Details</Heading>
      <Box mt={2}>
        <Heading level='5' size='small'>
          Fabrication Process
        </Heading>
        <Box>
          {fromProcess.name !== forProcess.name && (
            <Text crossed mr={2}>
              {fromProcess.name}
            </Text>
          )}
          <Text>{forProcess.name}</Text>
          {forProcess.parentProcess && <span>,</span>}
          {forProcess.parentProcess && (
            <Text ml={1}>{forProcess.parentProcess.name}</Text>
          )}
        </Box>
      </Box>
      <Box mt={2}>
        <Heading level='5' size='small'>
          Material
        </Heading>
        <Box>
          {fromMaterial.name !== forMaterial.name && (
            <Text crossed mr={2}>
              {fromMaterial.name}
            </Text>
          )}
          <Text>{forMaterial.name}</Text>
          {forMaterial.parentProcess && (
            <Text>{forMaterial.parentProcess.name}</Text>
          )}
        </Box>
      </Box>
      <Box mt={2}>
        <Heading level='5' size='small'>
          Quantity
        </Heading>
        <Box>
          {fromQuantity !== forQuantity && (
            <Text crossed mr={2}>
              {fromQuantity}
            </Text>
          )}
          <Text>{forQuantity}</Text>
        </Box>
      </Box>
      <Box mt={2}>
        <Heading level='5' size='small'>
          Lead Time
        </Heading>
        <Box>
          {fromLeadTime !== forLeadTime && (
            <Text crossed mr={2}>
              {fromLeadTime}
            </Text>
          )}
          <Text>{forLeadTime} days</Text>
        </Box>
      </Box>
      {values && (
        <Box>
          {values.map((buildVal: any) => {
            const { valueBool, of } = buildVal;

            // For values === JobSpec
            const { name, valueType } = of;
            const valueKey = covertValueTypeToKey(valueType);
            const bValFor = normalizeBuildValue(buildVal[valueKey], of);
            // From values === RequestForQuote
            const fromValue = fromValues.find(
              (value: BuildValueModel) => value.of.name === name,
            );

            if (fromValue) {
              nameFrom = fromValue.of.name;
              valueTypeFrom = fromValue.of.valueType;

              bValFrom = normalizeBuildValue(
                fromValue[covertValueTypeToKey(valueTypeFrom)],
                fromValue.of,
              );
            }

            let booleanSymbol = '';
            const isBooleanValue = valueType === 'BOOL';
            if (isBooleanValue) {
              if (valueBool === true) booleanSymbol = '✓';
              else if (valueBool === false && fromValue.valueBool === true)
                booleanSymbol = '✘';
              else return null;
            }

            return (
              <React.Fragment key={name}>
                <Box mt={2}>
                  {nameFrom !== name && (
                    <Heading
                      level={5}
                      size='small'
                      textDecoration='line-through'
                      mr={2}
                    >
                      {nameFrom}
                    </Heading>
                  )}
                  <Heading level={5} size='small'>
                    {name} {booleanSymbol}
                  </Heading>
                </Box>
                <Box>
                  {bValFrom !== bValFor && !isBooleanValue && (
                    <Text crossed mr={2}>
                      {bValFrom}
                    </Text>
                  )}
                  <Text>{bValFor}</Text>
                </Box>
              </React.Fragment>
            );
          })}
        </Box>
      )}
    </Box>
  );
};
